export const userUtils = {
    getInitials
}

function getInitials (displayName: string): string
{
    const tokens = displayName.split(' ');

    if (tokens.length === 1)
    {
        const firstToken = tokens[0];

        if (firstToken === 'sysadmin')
            return 'SYS';

        if (firstToken.length === 1)
            return firstToken.toUpperCase();
        else
            return firstToken.substring(0, 2).toUpperCase();
    }

    if (tokens.length >= 2)
    {
        const firstToken = tokens[0];
        const lastToken = tokens[tokens.length - 1];

        return firstToken.substring(0, 1).toUpperCase() + lastToken.substring(0, 1).toUpperCase();
    }

    return 'N/A';
}